import axios from 'axios';
import { apiUrl } from './index';

export default {
  getItems(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/contracts`,
      params,
    });
  },
  getDomains({ search = '' } = {}) {
    const params = {};

    if (search.length > 2) {
      params.domainUrl = search;
    }

    return axios({
      method: 'get',
      url: `${apiUrl}/contracts/domains`,
      params,
    });
  },
  createItem(item) {
    return axios({
      method: 'post',
      url: `${apiUrl}/contracts`,
      data: {
        ...item,
      },
    });
  },
  updateItem(contract) {
    return axios({
      method: 'put',
      url: `${apiUrl}/contracts/${contract.id}`,
      data: {
        ...contract,
      },
    });
  },
  getRedirect({ id }) {
    return axios({
      method: 'post',
      url: `${apiUrl}/contracts/billing/${id}`
    });
  },
  getItem({ id }) {
    return axios({
      method: 'get',
      url: `${apiUrl}/contracts/${id}`,
    });
  },
  getContractTypes() {
    return axios({
      method: 'get',
      url: `${apiUrl}/contracts/types`,
    });
  },
  getStatuses() {
    return axios({
      method: 'get',
      url: `${apiUrl}/contracts/statuses`,
    });
  },
  getPaymentTypes() {
    return axios({
      method: 'get',
      url: `${apiUrl}/contracts/payment_types`,
    });
  },
  setBilling(query) {
    return axios({
      method: 'post',
      url: `${apiUrl}/contracts/${query.id}/billing`,
      data: {
        ...query,
      },
    });
  },
  setDomain(query) {
    return axios({
      method: 'post',
      url: `${apiUrl}/contracts/${query.id}/domain`,
      data: {
        ...query,
      },
    });
  },
  addCapAmount(query) {
    return axios({
      method: 'post',
      url: `${apiUrl}/contracts/${query.id}/capping-discount`,
      data: {
        ...query,
      },
    });
  },
  removeCapAmount(id) {
    return axios({
      method: 'delete',
      url: `${apiUrl}/contracts/${id}/capping-discount`,
    });
  },
  getPrices({ id }) {
    return axios({
      method: 'get',
      url: `${apiUrl}/contracts/${id}/price`,
    });
  },
  addPrice(query) {
    return axios({
      method: 'post',
      url: `${apiUrl}/contracts/${query.id}/price`,
      data: {
        ...query,
      },
    });
  },
  removePrice(item) {
    return axios({
      method: 'delete',
      url: `${apiUrl}/contracts/${item.id}/price/${item.price_id}`,
    });
  },
};
